module.exports = __webpack_public_path__ + "img/icon_RegistrationCross.75069656.svg";